<template>
  <div class="connect-contact-preview" @click="$emit('click')">
    <div class="preview__avatar">
      <div class="chat-preview__image-wrapper">
        <div
          class="chat-preview__avatar"
          :style="{ backgroundImage: 'url(' + picture + ')' }"
        >
          <div class="flag__floating">
            <flag class="flag" :iso="nationality" />
          </div>
        </div>
      </div>
    </div>

    <div class="preview__details">
      <div class="connect-data">
        <b style="word-break: break-word">{{ name }}</b>
        <div style="font-size: 12px">
          {{ detail1 }}
        </div>
        <div style="font-size: 12px">
          {{ detail2 }}
        </div>
      </div>
    </div>

    <div class="preview__delete">
      <v-btn
        v-if="showRemoveButton"
        @click.stop="deleteDialog = true"
        class="connect-question-remove"
        flat
        icon
        color="red"
      >
        <v-icon>mdi-undo-variant</v-icon>
      </v-btn>
    </div>

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card class="dialog">
        <v-card-title class="headline text-xs-left"
          >Connect-Anfrage zurücknehmen</v-card-title
        >

        <v-card-text class="text-xs-left">
          Möchtest du die Connect-Anfrage wirklich zurücknehmen?
          <b>Bist du dir sicher?</b>
        </v-card-text>

        <v-card-actions style="justify-content: center">
          <v-btn text @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn
            :loading="loading"
            color="red white--text"
            text
            @click="deleteApplication"
            >Ja</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { db } from '@/db';

export default {
  name: 'connect-preview',

  data() {
    return {
      deleteDialog: false,
      loading: false,
    };
  },

  props: {
    name: {
      type: String,
      default: '',
    },

    picture: {
      type: String,
      default: '',
    },
    detail1: {
      type: String,
      default: '',
    },
    detail2: {
      type: String,
      default: '',
    },
    nationality: {
      type: String,
      default: '',
    },
    showRemoveButton: {
      type: Boolean,
      default: false,
    },
    selectedProfile: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapState(['bindedUserData', 'user_data']),

    shortMsg() {
      let shortMsg = this.msg;
      if (shortMsg && shortMsg.length > 20) {
        shortMsg = `${shortMsg.slice(0, 20)}...`;
      }
      return shortMsg;
    },

    isTrainer() {
      return this.user_data.userType === 'trainer';
    },
  },

  methods: {
    async deleteApplication() {
      this.loading = true;
      const collection = this.isTrainer ? 'trainers' : 'users';
      const batch = db.batch();

      // update user applied teams
      const applicationsWithoutCurrentTeam = this.user_data.applied_teams.filter(
        (application) => application !== this.selectedProfile.id,
      );
      this.user_data.applied_teams = applicationsWithoutCurrentTeam;

      const refLoggedUser = db.collection(collection).doc(this.user_data.id);
      batch.update(refLoggedUser, { applied_teams: applicationsWithoutCurrentTeam });

      // update team applications
      const applicationType = this.isTrainer ? 'trainer_applications' : 'applications';
      const applicationsWithoutCurrentUser = this.selectedProfile[
        applicationType
      ].filter((application) => application !== this.user_data.id);
      const updatedApplications = this.isTrainer
        ? {
            trainer_applications: applicationsWithoutCurrentUser,
            newApplication: null,
          }
        : {
            applications: applicationsWithoutCurrentUser,
            newApplication: null,
          };

      const refTeam = db.collection('teams').doc(this.selectedProfile.id);
      batch.update(refTeam, updatedApplications);

      batch
        .commit()
        .then(() => {
          this.$emit('updateAppliedTeams', this.selectedProfile);
          this.loading = false;
          this.deleteDialog = false;
        })
        .catch((err) => {
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Connect-Anfrage speichern Fehler',
          });
          console.log({ err });
        });
    },
  },
};
</script>
